//------------------------------------------------------------------------------
// メニュー状態 リデューサー
//------------------------------------------------------------------------------
import { combineReducers } from 'redux';
import types from './types';

/**
 * メニュー項目展開状態
 */
const expandedItems = (state = [], action) => {
  switch (action.type) {
    case types.EXPANDED_ITEMS: return action.expandedItems;
    default: return state;
  }
};

// エクスポート
const reducers = combineReducers({
  expandedItems,
});
export default reducers;
